import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import Switch from "react-switch";
import appStyles from "../../../../app.module.css";
import ConfigContext from "../../../../context/config-context";
import AppConstants from "../../../classes/constants";
import ErrorMsg from "../../../components/error-msg/error-msg";
import {
  quoteBathroomOptions,
  quoteBedroomOptions,
  quoteFormInitialValues,
  quoteFormValidationSchema,
} from "../../config/quote-config";
import styles from "./quote-form.module.css";

const QuoteFormHeading = ({ values, defaultQuote, template }) => {

  if (
    values.structural_inspection &&
    values.conveyancing &&
    template === AppConstants.QUOTE_SERVICES.DEFAULT
  ) {
    return defaultQuote === AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
      ? "Get A Pre-purchase Property Inspection & Conveyancing Quote"
      : "Get A Conveyancing and Pre-purchase Property Inspection Quote";
  } else if (
    values.conveyancing &&
    template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
  ) {
    return "GET A PROPERTY CONVEYANCING QUOTE IN 60 SECONDS";
  } else if (values.structural_inspection) {
    return "Get A Pre-purchase Property Inspection Quote";
  } else if (values.conveyancing) {
    return "Get An Instant Conveyancing Quote";
  } else {
    return defaultQuote === AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
      ? "Get A Pre-purchase Property Inspection Quote"
      : "Get An Instant Conveyancing Quote";
  }
};

const QuoteForm = (props) => {
  const { defaultQuote, internalQuote, template } = useContext(ConfigContext);
  const [initialValues, setInitialValues] = useState(quoteFormInitialValues);

  useEffect(() => {
    if (defaultQuote === AppConstants.QUOTE_SERVICES.CONVEYANCING) {
      setInitialValues((previousValues) => ({
        ...previousValues,
        conveyancing: true,
      }));
    }
    if (defaultQuote === AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION) {
      setInitialValues((previousValues) => ({
        ...previousValues,
        structural_inspection: true,
      }));
    }
  }, [defaultQuote]);

  const onSubmit = (values) => {
    const formData = new FormData();
    formData.append("action", "rsquote_handle_submit_quote_form");
    formData.append("internal_quote", internalQuote);
    formData.append(
      "quote_page",
      defaultQuote === AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
        ? "structural-inspections"
        : "get-quote"
    );
    formData.append("first_name", values.first_name || "");
    formData.append("surname", values.surname || "");
    formData.append("email", values.email || "");
    formData.append("phone", values.phone || "");
    if (values.conveyancing) {
      formData.append("services[]", AppConstants.QUOTE_SERVICES.CONVEYANCING);
      formData.append("type", values.type || "buyer");
      if (values.type === "buyer" || values.type === "both") {
        formData.append("purchase_price", values.purchase_price);
        if (values.first_home_buyer) {
          formData.append("first_home_buyer", true);
        }
        if (values.first_home_buyer && values.vacant_land) {
          formData.append("vacant_land", true);
        }
        if (values.property_strata_titled) {
          formData.append("property_strata_titled", true);
        }
        // Not in used right now
        // if (values.property_residential_established) {
        //   formData.append("property_residential_established", true);
        // }
        // if (
        //   !values.property_residential_established &&
        //   values.vacant_land &&
        //   values.contract_signed
        // ) {
        //   formData.append("contract_signed", true);
        // }
      }
      if (values.type === "seller" || values.type === "both") {
        formData.append("sale_price", values.sale_price);
        if (values.is_property_mortgaged) {
          formData.append("is_property_mortgaged", true);
        }
        if (values.is_property_deceased_estate) {
          formData.append("is_property_deceased_estate", true);
        }
      }
    }
    if (values.structural_inspection) {
      formData.append(
        "services[]",
        AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
      );
      formData.append("property_address", values.property_address);
      formData.append("property_suburb", values.property_suburb);
      formData.append("bedroom_count", values.bedroom_count);
      formData.append("bathroom_count", values.bathroom_count);
      // formData.append("timber_pest", values.timber_pest);

      formData.append(
        "inspection_type[]",
        AppConstants.QUOTE_INSPECTION_TYPES.STRUCTURAL
      );

      if (values.timber_pest) {
        formData.append(
          "inspection_type[]",
          AppConstants.QUOTE_INSPECTION_TYPES.TIMBER_PEST
        );
      }
    }
    props.submit(formData);
  };

  return (
    <div
      className={`${styles.quoteFormWrapper} ${
        template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
          ? styles.insideShowcaseQuoteFormWrapper
          : ""
      }`}
    >
      <Formik
        initialValues={initialValues}
        validationSchema={quoteFormValidationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          setFieldValue,
          setFieldTouched,
          touched,
          errors,
          isValid,
          dirty,
        }) => (
          <Form>
            <h1
              className={`${appStyles.textCenter} ${appStyles.colorPrimary} ${
                template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                  ? appStyles.colorWhite
                  : ""
              }`}
            >
              <QuoteFormHeading
                values={values}
                defaultQuote={defaultQuote}
                template={template}
              />
            </h1>
            <div className={appStyles.formRow}>
              <div
                className={`${appStyles.formField} ${
                  values.first_name ? appStyles.hasValue : ""
                } ${
                  touched.first_name && errors.first_name
                    ? appStyles.hasError
                    : ""
                }`}
              >
                <Field type="text" id="first_name" name="first_name" />
                <label htmlFor="first_name">First Name</label>
                <ErrorMessage name="first_name" component={ErrorMsg} />
              </div>
              <div
                className={`${appStyles.formField} ${
                  values.surname ? appStyles.hasValue : ""
                } ${
                  touched.surname && errors.surname ? appStyles.hasError : ""
                }`}
              >
                <Field type="text" id="surname" name="surname" />
                <label htmlFor="surname">Last Name</label>
                <ErrorMessage name="surname" component={ErrorMsg} />
              </div>
            </div>
            <div className={appStyles.formRow}>
              <div
                className={`${appStyles.formField} ${
                  values.email ? appStyles.hasValue : ""
                } ${touched.email && errors.email ? appStyles.hasError : ""}`}
              >
                <Field type="email" id="email" name="email" />
                <label htmlFor="email">Email</label>
                <ErrorMessage name="email" component={ErrorMsg} />
              </div>
              <div
                className={`${appStyles.formField} ${
                  values.phone ? appStyles.hasValue : ""
                } ${touched.phone && errors.phone ? appStyles.hasError : ""}`}
              >
                <Field
                  type="text"
                  id="phone"
                  name="phone"
                  onChange={(e) => {
                    setFieldValue(
                      "phone",
                      e.target?.value?.replace(/\D/g, "") || ""
                    );
                  }}
                />
                <ErrorMessage name="phone" component={ErrorMsg} />
                <label htmlFor="phone">Phone Number</label>
              </div>
            </div>
            <div
              className={`${styles.hasQuoteBlock} ${
                defaultQuote ===
                AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
                  ? styles.hasInspectionQuoteBlock
                  : styles.hasConveyancingQuoteBlock
              }`}
            >
              <div className={styles.quoteForm}>
                <div className={styles.quoteFormBlockHeader}>
                  <div className={styles.formFieldCheckbox}>
                    <label htmlFor="conveyancing">
                      Conveyancing Fee Quote
                      <Field
                        type="checkbox"
                        id="conveyancing"
                        name="conveyancing"
                        onChange={(e) => {
                          setFieldValue("conveyancing", e.target.checked);
                          // setFieldValue(
                          //   "type",
                          //   e.target.checked ? "buyer" : ""
                          // );
                          setFieldValue("purchase_price", "");
                          setFieldValue("sale_price", "");
                          setFieldValue("first_home_buyer", false);
                          setFieldValue("property_strata_titled", false);
                          // setFieldValue(
                          //   "property_residential_established",
                          //   e.target.checked ? true : false
                          // );
                          setFieldValue("vacant_land", false);
                          // setFieldValue("contract_signed", false);
                          setFieldValue("is_property_mortgaged", false);
                          setFieldValue("is_property_deceased_estate", false);
                        }}
                        checked={values.conveyancing || false}
                        disabled={
                          defaultQuote ===
                            AppConstants.QUOTE_SERVICES.CONVEYANCING &&
                          values.conveyancing
                        }
                      />
                      <span
                        className={`${styles.checkMark} ${
                          defaultQuote ===
                            AppConstants.QUOTE_SERVICES.CONVEYANCING &&
                          values.conveyancing &&
                          appStyles.buttonDisabled
                        }`}
                      ></span>
                    </label>
                    <ErrorMessage name="conveyancing" component={ErrorMsg} />
                  </div>
                </div>

                {values.conveyancing && (
                  <div className={styles.quoteFormBlockContent}>
                    <div className={styles.formFieldRadio}>
                      <div className={styles.formFieldRadioLabel}>
                        {template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                          ? "I am"
                          : "Are you Buying or Selling?"}
                      </div>
                      <div className={styles.formFieldRadioElement}>
                        <label htmlFor="buyingRadio">
                          <Field
                            type="radio"
                            value={AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER}
                            id="buyingRadio"
                            name="type"
                            //disabled={values.structural_inspection || false}
                            disabled={
                              defaultQuote ===
                              AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
                                ? false
                                : values.structural_inspection || false
                            }
                            onChange={(e) => {
                              setFieldValue(
                                "type",
                                e.target.checked
                                  ? AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER
                                  : ""
                              );
                              setFieldValue("purchase_price", "");
                              setFieldTouched("purchase_price", false);
                              setFieldValue("sale_price", "");
                              setFieldTouched("sale_price", false);
                              setFieldValue("first_home_buyer", false);
                              setFieldValue("property_strata_titled", false);
                              // setFieldValue(
                              //   "property_residential_established",
                              //   true
                              // );
                              setFieldValue("vacant_land", false);
                              // setFieldValue("contract_signed", false);
                              setFieldValue("is_property_mortgaged", false);
                              setFieldValue(
                                "is_property_deceased_estate",
                                false
                              );
                            }}
                          />
                          <span className={styles.formFieldRadioMark}>
                            Buying
                          </span>
                        </label>
                        <label htmlFor="sellingRadio">
                          <Field
                            type="radio"
                            value={AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER}
                            id="sellingRadio"
                            name="type"
                            disabled={values.structural_inspection || false}
                            onChange={(e) => {
                              setFieldValue(
                                "type",
                                e.target.checked
                                  ? AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER
                                  : ""
                              );
                              setFieldValue("purchase_price", "");
                              setFieldTouched("purchase_price", false);
                              setFieldValue("sale_price", "");
                              setFieldTouched("sale_price", false);
                              setFieldValue("first_home_buyer", false);
                              setFieldValue("property_strata_titled", false);
                              // setFieldValue(
                              //   "property_residential_established",
                              //   false
                              // );
                              setFieldValue("vacant_land", false);
                              // setFieldValue("contract_signed", false);
                              setFieldValue("is_property_mortgaged", false);
                              setFieldValue(
                                "is_property_deceased_estate",
                                false
                              );
                              // setFieldValue("structural_inspection", false);
                              // setFieldValue("timber_pest", false);
                            }}
                          />
                          <span
                            className={`${styles.formFieldRadioMark} ${styles.bx0}`}
                          >
                            Selling
                          </span>
                        </label>
                        <label htmlFor="bothRadio">
                          <Field
                            type="radio"
                            value={AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH}
                            id="bothRadio"
                            name="type"
                            //disabled={values.structural_inspection || false}
                            disabled={
                              defaultQuote ===
                              AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION
                                ? false
                                : values.structural_inspection || false
                            }
                            onChange={(e) => {
                              setFieldValue(
                                "type",
                                e.target.checked
                                  ? AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH
                                  : ""
                              );
                              setFieldValue("purchase_price", "");
                              setFieldTouched("purchase_price", false);
                              setFieldValue("sale_price", "");
                              setFieldTouched("sale_price", false);
                              setFieldValue("first_home_buyer", false);
                              setFieldValue("property_strata_titled", false);
                              // setFieldValue(
                              //   "property_residential_established",
                              //   false
                              // );
                              setFieldValue("vacant_land", false);
                              // setFieldValue("contract_signed", false);
                              setFieldValue("is_property_mortgaged", false);
                              setFieldValue(
                                "is_property_deceased_estate",
                                false
                              );
                            }}
                          />
                          <span className={styles.formFieldRadioMark}>
                            Both
                          </span>
                        </label>
                      </div>
                      <ErrorMessage name="type" component={ErrorMsg} />
                    </div>
                    {/* -------------------------------------------------------------------------------- */}
                    {(values.type ===
                      AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH ||
                      values.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER) && (
                      <>
                        <div className={appStyles.formRow}>
                          <div
                            className={`${appStyles.formField} ${
                              values.purchase_price ? appStyles.hasValue : ""
                            } ${
                              touched.purchase_price && errors.purchase_price
                                ? appStyles.hasError
                                : ""
                            }`}
                          >
                            <Field
                              type="text"
                              id="purchase_price"
                              name="purchase_price"
                              onChange={(e) => {
                                setFieldValue(
                                  "purchase_price",
                                  parseInt(
                                    e.target?.value?.replace(/\D/g, "") || ""
                                  ) || ""
                                );
                              }}
                            />
                            <label htmlFor="purchase_price">
                              Purchase Price
                            </label>
                            <ErrorMessage
                              name="purchase_price"
                              component={ErrorMsg}
                            />
                          </div>
                        </div>
                        <div className={styles.formFieldSwitch}>
                          <label htmlFor="first_home_buyer">
                            Do you qualify for the First Home Owner's Grant?
                          </label>
                          <Switch
                            id="first_home_buyer"
                            name="first_home_buyer"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            onChange={(checked) =>
                              setFieldValue("first_home_buyer", checked)
                            }
                            checked={values.first_home_buyer || false}
                          />
                        </div>
                        {values.first_home_buyer && (
                          <div className={styles.formFieldSwitch}>
                            <label htmlFor="vacant_land">
                              Is the property vacant land?
                            </label>
                            <Switch
                              id="vacant_land"
                              name="vacant_land"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              onColor={
                                template ===
                                AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                  ? "#C3005B"
                                  : "#73C132"
                              }
                              offColor="#C4C4C4"
                              handleDiameter={18}
                              height={20}
                              width={40}
                              onChange={(checked) => {
                                setFieldValue("vacant_land", checked);
                                // setFieldValue("contract_signed", false);
                              }}
                              checked={values.vacant_land || false}
                            />
                          </div>
                        )}
                        <div className={styles.formFieldSwitch}>
                          <label htmlFor="property_strata_titled">
                            Is the property strata titled?
                          </label>
                          <Switch
                            id="property_strata_titled"
                            name="property_strata_titled"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            onChange={(checked) =>
                              setFieldValue("property_strata_titled", checked)
                            }
                            checked={values.property_strata_titled || false}
                          />
                        </div>

                        {/* <div className={styles.formFieldSwitch}>
                          <label htmlFor="structural_inspection">
                            Add a Pre-purchase Structural Inspection Quote
                          </label>
                          <Switch
                            id="structural_inspection"
                            name="structural_inspection"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            onChange={(checked) => {
                              setFieldValue("structural_inspection", checked);
                              setFieldValue(
                                "timber_pest",
                                checked ? values.timber_pest : false
                              );
                            }}
                            checked={values.structural_inspection || false}
                          />
                        </div> */}

                        {/* {values.structural_inspection && (
                          <div className={styles.formFieldSwitch}>
                            <label htmlFor="timber_pest">
                              Timber Pest Inspection add-on
                            </label>
                            <Switch
                              id="timber_pest"
                              name="timber_pest"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              onColor={
                                template ===
                                AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                  ? "#C3005B"
                                  : "#73C132"
                              }
                              offColor="#C4C4C4"
                              handleDiameter={18}
                              height={20}
                              width={40}
                              onChange={(checked) =>
                                setFieldValue("timber_pest", checked)
                              }
                              checked={values.timber_pest || false}
                            />
                          </div>
                        )} */}

                        {/* <div className={styles.formFieldSwitch}>
                          <label htmlFor="property_residential_established">
                            Is the property residential established?
                          </label>
                          <Switch
                            id="property_residential_established"
                            name="property_residential_established"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            disabled={values.structural_inspection || false}
                            onChange={(checked) => {
                              setFieldValue(
                                "property_residential_established",
                                checked
                              );
                              setFieldValue("vacant_land", false);
                              setFieldValue("contract_signed", false);
                            }}
                            checked={
                              values.property_residential_established || false
                            }
                          />
                        </div> */}
                        {/* {values.vacant_land && (
                          <div className={styles.formFieldSwitch}>
                            <label htmlFor="contract_signed">
                              Will you have a building contract signed before
                              settlement?
                            </label>
                            <Switch
                              id="contract_signed"
                              name="contract_signed"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                              offColor="#C4C4C4"
                              handleDiameter={18}
                              height={20}
                              width={40}
                              onChange={(checked) =>
                                setFieldValue("contract_signed", checked)
                              }
                              checked={values.contract_signed || false}
                            />
                          </div>
                        )} */}
                      </>
                    )}

                    {(values.type ===
                      AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH ||
                      values.type ===
                        AppConstants.QUOTE_CONVEYANCING_TYPES.SELLER) && (
                      <>
                        <div className={appStyles.formRow}>
                          <div
                            className={`${appStyles.formField} ${
                              values.sale_price ? appStyles.hasValue : ""
                            } ${
                              touched.sale_price && errors.sale_price
                                ? appStyles.hasError
                                : ""
                            }`}
                          >
                            <Field
                              type="text"
                              id="sale_price"
                              name="sale_price"
                              onChange={(e) => {
                                setFieldValue(
                                  "sale_price",
                                  parseInt(
                                    e.target?.value?.replace(/\D/g, "") || ""
                                  ) || ""
                                );
                              }}
                            />
                            <label htmlFor="sale_price">Sale Price</label>
                            <ErrorMessage
                              name="sale_price"
                              component={ErrorMsg}
                            />
                          </div>
                        </div>
                        <div className={styles.formFieldSwitch}>
                          <label htmlFor="is_property_mortgaged">
                            Is the property mortgaged?
                          </label>
                          <Switch
                            id="is_property_mortgaged"
                            name="is_property_mortgaged"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            onChange={(checked) =>
                              setFieldValue("is_property_mortgaged", checked)
                            }
                            checked={values.is_property_mortgaged || false}
                          />
                        </div>
                        <div className={styles.formFieldSwitch}>
                          <label htmlFor="is_property_deceased_estate">
                            Is the property part of a deceased estate?
                          </label>
                          <Switch
                            id="is_property_deceased_estate"
                            name="is_property_deceased_estate"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor={
                              template ===
                              AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                                ? "#C3005B"
                                : "#73C132"
                            }
                            offColor="#C4C4C4"
                            handleDiameter={18}
                            height={20}
                            width={40}
                            onChange={(checked) =>
                              setFieldValue(
                                "is_property_deceased_estate",
                                checked
                              )
                            }
                            checked={
                              values.is_property_deceased_estate || false
                            }
                          />
                        </div>
                        {values.is_property_deceased_estate ? (
                          <div className={styles.formFieldSwitchInfo}>
                            Where a deceased person is shown on the title as the
                            registered proprietor.
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>
                )}
              </div>
 
             {(values?.type === AppConstants.QUOTE_CONVEYANCING_TYPES.BUYER ||
                values?.type ===
                  AppConstants.QUOTE_CONVEYANCING_TYPES.BOTH) && ( 
              <div className={styles.quoteForm}>
                <div className={styles.quoteFormBlockHeader}>
                  <div className={styles.formFieldCheckbox}>
                    <label htmlFor="structural_inspection">
                      Pre-purchase Structural Inspection Quote
                      <Field
                        type="checkbox"
                        id="structural_inspection"
                        name="structural_inspection"
                        onChange={(e) => {
                          // if (values.type === "seller") {
                          //   setFieldValue("type", "buyer");
                          // }
                          setFieldValue("first_home_buyer", false);
                          setFieldValue("property_strata_titled", false);
                          // setFieldValue(
                          //   "property_residential_established",
                          //   true
                          // );
                          setFieldValue("vacant_land", false);
                          // setFieldValue("contract_signed", false);
                          setFieldValue("is_property_mortgaged", false);
                          setFieldValue("is_property_deceased_estate", false);
                          setFieldValue("property_address", "");
                          setFieldValue("property_suburb", "");
                          setFieldValue("bedroom_count", "");
                          setFieldValue("bathroom_count", "");
                          setFieldValue("timber_pest", false);
                          setFieldValue(
                            "structural_inspection",
                            e.target.checked
                          );
                        }}
                        checked={values.structural_inspection || false}
                        disabled={
                          defaultQuote ===
                            AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION &&
                          values.structural_inspection
                        }
                      />
                      <span
                        className={`${styles.checkMark} ${
                          defaultQuote ===
                            AppConstants.QUOTE_SERVICES.STRUCTURAL_INSPECTION &&
                          values.structural_inspection &&
                          appStyles.buttonDisabled
                        }`}
                      ></span>
                    </label>
                    <ErrorMessage
                      name="structural_inspection"
                      component={ErrorMsg}
                    />
                  </div>
                </div>
                {values.structural_inspection && (
                  <div className={styles.quoteFormBlockContent}>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          values.property_address ? appStyles.hasValue : ""
                        } ${
                          touched.property_address && errors.property_address
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field
                          type="text"
                          id="property_address"
                          name="property_address"
                        />
                        <ErrorMessage
                          name="property_address"
                          component={ErrorMsg}
                        />
                        <label htmlFor="property_address">
                          Property Address
                        </label>
                      </div>
                      <div
                        className={`${appStyles.formField} ${
                          values.property_suburb ? appStyles.hasValue : ""
                        } ${
                          touched.property_suburb && errors.property_suburb
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field
                          type="text"
                          id="property_suburb"
                          name="property_suburb"
                        />
                        <ErrorMessage
                          name="property_suburb"
                          component={ErrorMsg}
                        />
                        <label htmlFor="property_suburb">Property Suburb</label>
                      </div>
                    </div>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          appStyles.hasValue
                        } ${
                          touched.bedroom_count && errors.bedroom_count
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field
                          as="select"
                          id="bedroom_count"
                          name="bedroom_count"
                        >
                          {!values.bedroom_count && (
                            <option value="">Select</option>
                          )}
                          {quoteBedroomOptions.map((option) => {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          })}
                        </Field>
                        <label htmlFor="bedroom_count">
                          Number of Bedrooms
                        </label>
                        <ErrorMessage
                          name="bedroom_count"
                          component={ErrorMsg}
                        />
                        {values.bedroom_count === 6 && (
                          <div className={styles.exceedLimitText}>
                            Call{" "}
                            <a
                              href={`tel:${AppConstants.PHONE_NUMBER}`}
                              className={appStyles.telphoneLink}
                            >
                              {AppConstants.FORMATTED_PHONE_NUMBER}
                            </a>{" "}
                            for a custom quote
                          </div>
                        )}
                      </div>
                      {/* ----------------- */}

                      <div
                        className={`${appStyles.formField} ${
                          appStyles.hasValue
                        } ${
                          touched.bathroom_count && errors.bathroom_count
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field
                          as="select"
                          id="bathroom_count"
                          name="bathroom_count"
                        >
                          {!values.bathroom_count && (
                            <option value="">Select</option>
                          )}
                          {quoteBathroomOptions.map((option) => {
                            return (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            );
                          })}
                        </Field>
                        <label htmlFor="bathroom_count">
                          Number of Bathrooms
                        </label>
                        <ErrorMessage
                          name="bathroom_count"
                          component={ErrorMsg}
                        />
                      </div>
                    </div>
                    <div className={styles.formFieldSwitch}>
                      <label htmlFor="timber_pest">
                        Timber Pest Inspection
                      </label>
                      <Switch
                        id="timber_pest"
                        name="timber_pest"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor={
                          template === AppConstants.QUOTE_SERVICES.LP_SHOWCASE
                            ? "#C3005B"
                            : "#73C132"
                        }
                        offColor="#C4C4C4"
                        handleDiameter={18}
                        height={20}
                        width={40}
                        onChange={(checked) =>
                          setFieldValue("timber_pest", checked)
                        }
                        checked={values.timber_pest || false}
                      />
                    </div>
                  </div>
                )}
              </div>
               )} 
            </div>
            {props.error && (
              <div
                className={`${appStyles.colorDanger} ${appStyles.textCenter}`}
              >
                {props.error}
              </div>
            )}
            <div
              className={`${styles.formFieldSubmit} ${appStyles.textCenter}`}
            >
              <button
                type="submit"
                className={`${appStyles.hasButtonLoading} ${
                  props.isSubmitting && appStyles.rezziButtonLoading
                } ${
                  (!dirty ||
                    !isValid ||
                    props.isSubmitting ||
                    values.bedroom_count === 6) &&
                  appStyles.buttonDisabled
                }`}
                disabled={
                  !dirty ||
                  !isValid ||
                  props.isSubmitting ||
                  values.bedroom_count === 6
                }
              >
                {props.isSubmitting && (
                  <div className={appStyles.rezziButtonLoader}></div>
                )}
                {!props.isSubmitting && "View Quote"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default QuoteForm;


